export default [
  {
    path: "/dashboard",
    name: "dashboard",
    component: () => import("@/views/vserv/dashboard/Analytics.vue"),
  },
];
